import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { MatChipInputEvent } from '@angular/material';
import { Observable } from 'rxjs/Rx';
import { NotificationService, DataService, LoaderService, ErrorService, EVENTO, TYPEMESSAGE, UtilityService } from "../../../../shared/session/index";
import { SessionInfo } from "../../../../shared/session/SessionInfo";
import { Ioffice } from './../shared/office.model';

@Injectable({
  providedIn: 'root',
})
export class OfficeService {
  constructor(private dataService: DataService,
    private loaderService: LoaderService,
    private utilityService: UtilityService,
    private sessionInfo: SessionInfo) { }

  insertarOfficeUrl: string = 'Office/Insertar';
  actualizarOfficeUrl: string = 'Office/Actualizar';
  obtenerOfficeUrl: string = 'Office/obtener';
  listarOfficeUrl: string = 'Office/Listar';
  listarPorOfficeUrl: string = 'Office/ListarPor';
  asignarOfficeAplicacionUrl: string = 'officeAplicacion/insertar';
  deleteOfficeAplicacionUrl: string = 'officeAplicacion/delete';
  // cReporteEmisionPrefacturaUrl: string = 'DownloadFile/cReporteEmisionPrefactura';

  listarOfficeAll() {
    this.dataService.set(this.listarOfficeUrl);
    return this.dataService.execGetJson();
  }

  listarOffice(filtro: string, pageIndex: number, pageSize: number, status?: boolean): any {
    let parameters = new HttpParams();
    parameters = parameters.append("pFiltro", String(filtro));
    parameters = parameters.append("pageIndex", String(pageIndex));
    parameters = parameters.append("pageSize", String(pageSize));
    parameters = parameters.append("empresaID", String(this.sessionInfo.getEmpresaID()));
    parameters = parameters.append("status", status != null ? String(status) : null);
    this.dataService.set(this.listarPorOfficeUrl);
    return this.dataService.execGetJson(parameters);
  }

  toggleOfficeAcplicaion(OfficeID: number, AplicacionID: number, identificador: boolean) {
    let parameters: string;
    parameters = JSON.stringify({
      OfficeID: OfficeID,
      AplicacionID: AplicacionID,
    })

    if (identificador)
      this.dataService.set(this.asignarOfficeAplicacionUrl);
    else
      this.dataService.set(this.deleteOfficeAplicacionUrl);

    return this.dataService.execPostJson(parameters);
  }

  obtenerOffice(OfficeId: number): any {
    let parameters = new HttpParams();
    parameters = parameters.append("pKey", String(OfficeId));
    this.dataService.set(this.obtenerOfficeUrl);
    return this.dataService.execGetJson(parameters);
  }

  insertarOffice(office: Ioffice): any {
    let parameters: string;
    parameters = JSON.stringify({
      empresaID: this.sessionInfo.getEmpresaID(),
      name: office.Name,
      direccion: office.Direccion,
      referencia: office.Referencia,
      coordenadas: office.Coordenadas,
      descripcion: office.Descripcion,
      status: office.Status,
      UserCreation: this.sessionInfo.getCodUsuario(),
    });

    this.dataService.set(this.insertarOfficeUrl);
    return this.dataService.execPostJson(parameters);
  }

  actualizarOffice(office: Ioffice): any {
    let parameters: string;
    parameters = JSON.stringify({
      empresaID: this.sessionInfo.getEmpresaID(),
      ID: office.ID,
      name: office.Name,
      direccion: office.Direccion,
      referencia: office.Referencia,
      coordenadas: office.Coordenadas,
      descripcion: office.Descripcion,
      userlastupdate: this.sessionInfo.getCodUsuario(),
      status: office.Status,
    });
    this.dataService.set(this.actualizarOfficeUrl);
    return this.dataService.execPostJson(parameters);
  }
}
